import WorkOrderLink from "../../components/work/work-order/WorkOrderLink";
import WorkOrder from "../../models/workOrder";
import workOrderStatusHelper from "../../models/workOrderStatusHelper";
import workOrderTypeHelper from "../../models/workOrderTypeHelper";
import Moment from "react-moment";
import dateTimeHelper from "../../util/datetimeHelper";
import ServiceProvider from "../../models/serviceProvider";

const WorkOrderDispatchesView: React.FC<{ workOrder: WorkOrder }> = ({
  workOrder,
}) => {
  return (
    <>
      {workOrder.childrenWorkOrders.length > 0 && (
        <>
          <div className="d-flex justify-content-end align-items-center">
            {workOrder.childrenWorkOrders.length === 1 && (
              <div>{`${workOrder.childrenWorkOrders.length} dispatch`}</div>
            )}
            {workOrder.childrenWorkOrders.length === 0 ||
              (workOrder.childrenWorkOrders.length > 1 && (
                <div>{`${workOrder.childrenWorkOrders.length} dispatches`}</div>
              ))}
          </div>

          <div className="table-responsive">
            <table className="table table-hover table-responsive horizontal-center-td">
              <thead>
                <tr>
                  <th scope="col">Dispatch Order #</th>
                  <th scope="col">Trade</th>
                  <th scope="col">Work Order Type</th>
                  <th scope="col">DNE</th>
                  <th scope="col">Dispatch Order Status</th>
                  <th scope="col">Scheduled Date</th>
                  <th scope="col">Service Provider Name</th>
                  <th scope="col">Service Provider Email</th>
                  <th scope="col">Service Provider Phone</th>
                </tr>
              </thead>
              <tbody>
                {workOrder.childrenWorkOrders.map((dispatch: WorkOrder) => (
                  <tr
                    key={
                      workOrder.workOrderNumber +
                      "_details_" +
                      dispatch.workOrderNumber
                    }
                  >
                    <td>
                      <WorkOrderLink
                        workOrderNumber={dispatch.workOrderNumber}
                        canNavigate={true}
                      />
                    </td>
                    <td>{dispatch.trade.tradeName}</td>
                    <td>
                      {workOrderTypeHelper.getDisplayValue(
                        dispatch.workOrderType,
                      )}
                    </td>
                    <td>{dispatch.dneAmount}</td>
                    <td>
                      <span
                        className={workOrderStatusHelper.getBadgeClass(
                          dispatch.workOrderStatus,
                        )}
                      >
                        {workOrderStatusHelper.getDisplayValue(
                          dispatch.workOrderStatus,
                        )}
                      </span>
                    </td>
                    <td>
                      {dispatch.scheduledDate && (
                        <Moment format={dateTimeHelper.dateFormat}>
                          {dispatch.scheduledDate}
                        </Moment>
                      )}
                      {!dispatch.scheduledDate && <div>-</div>}
                    </td>
                    <td>
                      {ServiceProvider.getName(dispatch.toServiceProvider)}
                    </td>
                    <td>{dispatch.toServiceProvider?.email}</td>
                    <td>{dispatch.toServiceProvider?.phone}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {workOrder.childrenWorkOrders.length === 0 && <div>No Dispatches</div>}
    </>
  );
};

export default WorkOrderDispatchesView;
